"use strict";
// import { useState } from 'react';
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.CheckIsMobile = exports.SetUserName = exports.allowUser = exports.InterviewerDataModel = exports.UpdateStatus = exports.CheckNullEmptyUndefined = exports.UpdateRemark = exports.UpdateRatings = exports.uriCode = exports.ConsoleString = exports.ConsoleFile = exports.uriGid = exports.ParticipantModel = exports.UpdateInterviewActivityLog = exports.SaveUserScreenShort = exports.UpdateInterviewTime = exports.LeaveInterviewCall = exports.JoinCall = exports.GetInterviewDetails = void 0;
[];
var data2;
var data1;
var InterviewerData;
var isMobile;
var browserName;
var deviceInfo;
function GetInterviewDetails(code, osVersion, appVersion, osName) {
    return __awaiter(this, void 0, void 0, function () {
        var num_isMobile, getData, e_1, obj;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    num_isMobile = isMobile == 'true' ? 1 : 0;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, fetch(window.rAPI + "v1/Interview/Authentication", {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({
                                "code": code,
                                "groupId": uriGid,
                                "osVersion": osVersion,
                                "appVersion": appVersion,
                                "osName": osName,
                                "isMobile": num_isMobile
                            })
                        }).then(function (response) {
                            //console.log(response)
                            return response.json();
                        }).then(function (myJson) {
                            //console.log(myJson)
                            try {
                                data2 = myJson.data;
                                console.log("data2");
                                console.log(data2);
                                //console.log(data2.candidateTestId)
                                if (data2.candidateTestId == 0) {
                                    data1 = myJson;
                                }
                            }
                            catch (e) {
                                data1 = myJson;
                                //alert(data1);
                            }
                        })];
                case 2:
                    getData = _a.sent();
                    return [4 /*yield*/, getData];
                case 3:
                    _a.sent();
                    console.log("Authentication api called");
                    return [3 /*break*/, 5];
                case 4:
                    e_1 = _a.sent();
                    console.log("Authentication catch Block ::" + e_1);
                    if (e_1 != undefined) {
                        obj = {
                            isSuccess: false,
                            message: "Due to firewall restrictions, access to this page is limited to specific networks. To resolve this issue, please connect to a different network, such as your home WiFi or a network without these restrictions."
                        };
                        data1 = obj;
                    }
                    e_1 = e_1 + " :: Authentication API";
                    //Call Network Log API
                    fetch('/recording/LogForNetworkIssue?groupId=' + uriGid + '&verifyCode=' + code + '&errorMessage=' + e_1, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' }
                    });
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    });
}
exports.GetInterviewDetails = GetInterviewDetails;
var allowUser;
exports.allowUser = allowUser;
function JoinCall() {
    return __awaiter(this, void 0, void 0, function () {
        var getData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch(window.rAPI + "v1/Interview/JoinCall", {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                            "code": uriCode,
                            "groupId": uriGid,
                            "firstName": data2.userName,
                            "candidateTestId": data2.candidateTestId,
                            "logActivityInfo": { eventType: "Call" }
                        })
                    }).then(function (response) {
                        return response.json();
                    }).then(function (myJson) {
                        try {
                            if (data2.videoInterviewDetail != null) {
                                if (myJson.data != null && myJson.data != undefined) {
                                    data2.videoInterviewDetail.currentUtcDate = myJson.data.utcDate;
                                    currentTimestamp = Date.parse(data2.videoInterviewDetail.currentUtcDate.toString());
                                    if (myJson.data.isAnotherUserAvail == "notjoined") {
                                        exports.allowUser = allowUser = Promise.resolve("notjoined");
                                    }
                                    else if (myJson.data.isAnotherUserAvail == "true") {
                                        exports.allowUser = allowUser = Promise.resolve("true");
                                    }
                                    else {
                                        exports.allowUser = allowUser = Promise.resolve("false");
                                    }
                                    //console.log("COGBEE :: PI :: AllowUser :: " + allowUser);
                                    return myJson.data.isAnotherUserAvail;
                                }
                            }
                        }
                        catch (e) {
                        }
                    })];
                case 1:
                    getData = _a.sent();
                    return [4 /*yield*/, getData];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, allowUser];
                case 3:
                    _a.sent();
                    console.log("COGBEE :: JoinCall :: AllowUser :: " + allowUser);
                    console.log("JoinCall api called");
                    console.log(getData);
                    //console.log(getData.text());
                    //const response = getData.text();
                    //allowUser = response;
                    return [2 /*return*/, allowUser];
            }
        });
    });
}
exports.JoinCall = JoinCall;
function CheckIsMobile() {
    return __awaiter(this, void 0, void 0, function () {
        var getData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch("/recording/checkIsMobile", {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' }
                    }).then(function (response) {
                        //console.log(response)
                        return response.json();
                    }).then(function (myJson) {
                        //console.log(myJson)
                        try {
                            deviceInfo = myJson;
                        }
                        catch (e) {
                        }
                    })];
                case 1:
                    getData = _a.sent();
                    return [4 /*yield*/, getData];
                case 2:
                    _a.sent();
                    console.log("check is Mobile");
                    console.log(getData);
                    isMobile = deviceInfo.isMobile;
                    browserName = deviceInfo.browserName;
                    return [2 /*return*/];
            }
        });
    });
}
exports.CheckIsMobile = CheckIsMobile;
function LeaveInterviewCall() {
    return __awaiter(this, void 0, void 0, function () {
        var getData;
        return __generator(this, function (_a) {
            getData = fetch(window.rAPI + "v1/Interview/LeaveCall", {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    "code": uriCode,
                    "groupId": uriGid,
                    "firstName": data2.userName,
                    "candidateTestId": data2.candidateTestId,
                    "logActivityInfo": { eventType: "Call" }
                })
            });
            return [2 /*return*/];
        });
    });
}
exports.LeaveInterviewCall = LeaveInterviewCall;
var getGroupIdFromUrl = function () {
    var urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('groupId');
};
var getCodeFromUrl = function () {
    var urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('q');
};
var uriCode = getCodeFromUrl();
exports.uriCode = uriCode;
var uriGid = getGroupIdFromUrl();
exports.uriGid = uriGid;
var ParticipantModel = function () {
    if (data2 != undefined && data2.candidateTestId > 0) {
        if (data2.role == "Interviewer") {
            return {
                userId: data2.userId,
                candidateTestId: data2.candidateTestId,
                userName: data2.userName,
                role: data2.role,
                jobTitle: data2.jobTitle,
                status: data2.status,
                isMobile: isMobile,
                browserName: browserName,
                ratingsList: data2.ratingsList,
                htmlResumeURL: data2.htmlResumeURL,
                evalURL: data2.evalURL,
                videoInterviewDetail: data2.videoInterviewDetail,
                interpretationList: data2.interpretationList,
                isCapturePhoto: data2.isCapturePhoto
            };
        }
        else if (data2.role == "Spoc") {
            return {
                userId: data2.userId,
                candidateTestId: data2.candidateTestId,
                userName: data2.userName,
                role: data2.role,
                jobTitle: data2.jobTitle,
                status: data2.status,
                isMobile: isMobile,
                browserName: browserName,
                htmlResumeURL: data2.htmlResumeURL,
                evalURL: data2.evalURL,
                videoInterviewDetail: data2.videoInterviewDetail,
                isCapturePhoto: data2.isCapturePhoto
            };
        }
        else {
            return {
                userId: data2.userId,
                candidateTestId: data2.candidateTestId,
                userName: data2.userName,
                role: data2.role,
                isMobile: isMobile,
                browserName: browserName,
                jobTitle: data2.jobTitle,
                status: 2,
                videoInterviewDetail: data2.videoInterviewDetail,
                interpretationList: data2.interpretationList,
                isCapturePhoto: data2.isCapturePhoto
            };
        }
    }
    else {
        var message = data1 != undefined && data1.message != undefined ? data1.message : "";
        return {
            userId: 12222,
            candidateTestId: 12225,
            userName: "Rutul 12",
            role: message,
            jobTitle: "osa jo b",
            status: 2,
            isMobile: 'false',
            browserName: 'chrome',
            videoInterviewDetail: data2 === null || data2 === void 0 ? void 0 : data2.videoInterviewDetail,
            isCapturePhoto: false
        };
    }
};
exports.ParticipantModel = ParticipantModel;
//const fs = require('fs');
function ConsoleFile(obj) {
    fetch("/recording/consoleLogString?log=" + JSON.stringify(obj), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
    });
    //fs.writeFile("D:/VS19_WorkingProj/Azure_Video/communicationSample - Copy/communicationSample/Calling/JSLogFile.txt", JSON.stringify(obj), function (err:object) {
    //    if (err) {
    //        return console.log(err);
    //    }
    //    console.log("The file was saved!");
    //});
}
exports.ConsoleFile = ConsoleFile;
function UpdateStatus(id) {
    InterviewerData.status = id;
    data2.status = id;
}
exports.UpdateStatus = UpdateStatus;
function SetUserName(name) {
    data2.userName = name;
}
exports.SetUserName = SetUserName;
function UpdateRatings(id, score) {
    var _a;
    (_a = InterviewerData.ratingsList) === null || _a === void 0 ? void 0 : _a.forEach(function (item) {
        if (item.id == id) {
            item.score = score;
            var txtValue = document.getElementById("ratingTxtInput_" + item.id);
            if (CheckNullEmptyUndefined(score)) {
                txtValue.style.removeProperty("border-color");
            }
            else {
                txtValue.style.borderColor = "#ff0000";
            }
        }
    });
}
exports.UpdateRatings = UpdateRatings;
function UpdateRemark(id, remark) {
    var _a;
    (_a = InterviewerData.ratingsList) === null || _a === void 0 ? void 0 : _a.forEach(function (item) {
        if (item.id == id) {
            item.remark = remark;
            var txtValue = document.getElementById("txtArea_" + item.id);
            if (CheckNullEmptyUndefined(remark)) {
                txtValue.style.removeProperty("border-color");
            }
            else {
                txtValue.style.borderColor = "#ff0000";
            }
        }
    });
}
exports.UpdateRemark = UpdateRemark;
function CheckNullEmptyUndefined(val) {
    if (typeof (val) === "string") {
        val = val.trim();
    }
    if (val != null && val != "" && val != undefined) {
        return true;
    }
    return false;
}
exports.CheckNullEmptyUndefined = CheckNullEmptyUndefined;
var InterviewerDataModel = function () {
    if (InterviewerData != null && InterviewerData != undefined) {
        return InterviewerData;
    }
    else {
        InterviewerData = data2;
        return InterviewerData;
    }
};
exports.InterviewerDataModel = InterviewerDataModel;
function ConsoleString(obj) {
    fetch("/recording/consoleLogString?log=" + obj, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
    });
}
exports.ConsoleString = ConsoleString;
function UpdateInterviewTime(time) {
    return __awaiter(this, void 0, void 0, function () {
        var getData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    time = Math.floor(Number(time)).toString();
                    getData = fetch(window.rAPI + "v1/Interview/UpdateInterviewTime", {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                            "code": uriCode,
                            "groupId": uriGid,
                            "firstName": data2.userName,
                            "time": time,
                            "logActivityInfo": { eventType: "UpdateTime" }
                        })
                    }).then(function (response) {
                        console.log("responseUpdatetime");
                        console.log(response);
                        return response.json();
                    }).then(function (myJson) {
                        if (data2.videoInterviewDetail != null) {
                            data2.videoInterviewDetail.timer = myJson.data;
                        }
                        console.log(myJson);
                        //return myJson.data;
                    });
                    return [4 /*yield*/, getData];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
exports.UpdateInterviewTime = UpdateInterviewTime;
function SaveUserScreenShort(baseCode) {
    return __awaiter(this, void 0, void 0, function () {
        var searchString, lastIndex, getData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    searchString = "base64,";
                    lastIndex = baseCode.lastIndexOf(searchString);
                    if (lastIndex !== -1) {
                        baseCode = baseCode.substring(lastIndex + searchString.length);
                    }
                    getData = fetch(window.answerAPI + "AC/Image/Add/", {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                            "code": uriCode,
                            "fileImport": { fileBytes: baseCode }
                        })
                    }).then(function (response) {
                        return response.json();
                    }).then(function (myJson) {
                        var result = myJson;
                        if (result.isSuccess) {
                            data2.isCapturePhoto = true;
                        }
                        //return myJson.data;
                    });
                    return [4 /*yield*/, getData];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
exports.SaveUserScreenShort = SaveUserScreenShort;
function UpdateInterviewActivityLog(eventType, message) {
    return __awaiter(this, void 0, void 0, function () {
        var getData;
        return __generator(this, function (_a) {
            getData = fetch(window.rAPI + "v1/Interview/InterviewActivityLog", {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    "code": uriCode,
                    "groupId": uriGid,
                    "firstName": data2.userName,
                    "logActivityInfo": { eventType: eventType, message: message }
                })
            });
            return [2 /*return*/];
        });
    });
}
exports.UpdateInterviewActivityLog = UpdateInterviewActivityLog;
